import { render, staticRenderFns } from "./Household.vue?vue&type=template&id=61709a48&scoped=true&"
import script from "./Household.vue?vue&type=script&lang=js&"
export * from "./Household.vue?vue&type=script&lang=js&"
import style0 from "./Household.vue?vue&type=style&index=0&id=61709a48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61709a48",
  null
  
)

export default component.exports